import { render, staticRenderFns } from "./brand-list.vue?vue&type=template&id=5afca4dd&scoped=true"
import script from "./brand-list.vue?vue&type=script&lang=js"
export * from "./brand-list.vue?vue&type=script&lang=js"
import style0 from "./brand-list.vue?vue&type=style&index=0&id=5afca4dd&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afca4dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afca4dd')) {
      api.createRecord('5afca4dd', component.options)
    } else {
      api.reload('5afca4dd', component.options)
    }
    module.hot.accept("./brand-list.vue?vue&type=template&id=5afca4dd&scoped=true", function () {
      api.rerender('5afca4dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/brand-management/brand-list.vue"
export default component.exports